const mixin = {
  methods: {
    $errors($v) {
      const errs = []
      if ($v.$dirty) {
        if (
          $v.required === false ||
          $v.requiredIf === false ||
          $v.notEmpty === false
        ) {
          errs.push(this.$t('errors.required'))
        }
        if ($v.email === false) {
          errs.push(this.$t('errors.email'))
        }
        if ($v.minLength === false) {
          errs.push(this.$t('errors.minLength', [$v.$params.minLength.min]))
        }

        if ($v.maxLength === false) {
          errs.push(this.$t('errors.maxLength', [$v.$params.maxLength.max]))
        }
        if ($v.sameAsPassword === false) {
          errs.push(this.$t('errors.missmatch'))
        }
        if ($v.provenanceValidator === false) {
          errs.push(this.$t('errors.provenanceValidator'))
        }
      }
      return errs
    },
  },
}

export default {
  install(Vue) {
    Vue.mixin(mixin)
  },
}
